module.exports = __webpack_public_path__ + "static/rest-api1-c0953343ae7e1db81b3298dd1f0cd46b.png";